import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_OBJECT} from '../../metamodel/Concept';

export default class BusinessObjectNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_OBJECT;
	}
}
